import { render, staticRenderFns } from "./ReportsClient.vue?vue&type=template&id=70baaa3e&"
import script from "./ReportsClient.vue?vue&type=script&lang=js&"
export * from "./ReportsClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports